<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea;">
            <h2>{{pageTitle.title}}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{pageTitle.title}}</li>
            </ul>
        </div>
    </div>

    <div class="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"></div>
    <div class="shape-img2"><img src="assets/img/shape/shape2.png" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.png" alt="image"></div>
</section>

<section class="faq-area">
    <div class="container">
        <div class="faq-accordion">
            <div class="faq-sections">
                <i class='bx bx-wifi-0'></i>
                <span *ngFor="let section of faqAccordion;">
                    <a href="/faq#{{section.id}}">{{section.title}}</a>
                    <i class='bx bx-wifi-0'></i>
                </span>
            </div>
            <ul class="accordion" *ngFor="let section of faqAccordion; index as n">
                <h1 id={{section.id}}>{{section.title}}</h1>
                <li class="accordion-item" *ngFor="let q of section.questions; index as m">
                    <a class="accordion-title" href="javascript:void(0)" (click)="questionSelected(n, m)">
                        <i class='bx' [ngClass]="q.isOpen?'bx-chevron-down':'bx-chevron-right'"></i>
                        {{q.question}}
                    </a>
                    <div class="accordion-content" *ngIf="q.isOpen">
                        <p>{{q.answer}}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</section>